import { PutRecordCommand } from "@aws-sdk/client-firehose"

import {
  firehoseClient,
  firehoseDeliveryStreamName,
} from "utils/metrics/firehose-client"
import { useDefaultMetrics } from "utils/metrics/default-metrics"

enum MetricsEvents {
  REG_VIEW = "Registration-WebsiteViews",
}

const generatePutRecordCommand = (
  eventKey: string,
  streamName: string,
  props: { [key: string]: string | number | null }
) => {
  const stringifiedJSON =
    JSON.stringify({
      event: eventKey,
      properties: props,
    }) + "\n"

  const uint8array = new TextEncoder().encode(stringifiedJSON)
  const record = { Data: uint8array }

  const command = new PutRecordCommand({
    DeliveryStreamName: streamName,
    Record: record,
  })

  return command
}

const useMetrics = () => {
  const defaultProperties = useDefaultMetrics()

  const trackMetricsEvent = async (
    eventKey: string,
    eventProperties?: { [key: string]: string | number | null }
  ) => {
    try {
      const metricsData = {
        ...defaultProperties,
        ...eventProperties,
      }

      const command = generatePutRecordCommand(
        eventKey,
        firehoseDeliveryStreamName,
        metricsData
      )

      await firehoseClient.send(command)
    } catch (error) {
      console.log("firehoseClient putRecord error", error)
    }
  }

  return { trackMetricsEvent }
}

export { useMetrics, MetricsEvents }
